import React, { useState, useEffect } from 'react';
import {useDispatch } from "react-redux";

import { Card, Typography, Button } from "antd";
import IntlMessages from "../../../util/IntlMessages";


import StyledMenuOptions from "../../../components/StyledMenuOptions";
import Edit from "../../../assets/svg/Edit";
import Delete from "../../../assets/svg/Delete";

import { CardItem } from './CardItem';


const { Text } = Typography;

const SideCard = (props) => {

  const { items, title, style, children, activeAgents, onClick } = props;
  const [filteredListItems, setFilteredListItems] = useState([])
    const dispatch = useDispatch();


  useEffect(() => {

    if (items) {

      setFilteredListItems(items.map(item => {
        let isActive = false;
        let agentInfo = {};
        let s = 'pcOff';

        if (activeAgents && activeAgents.hasOwnProperty(item.device_access_token) && activeAgents[item.device_access_token]) {

          isActive = activeAgents[item.device_access_token]?.apps?.find(app => {
            return app.title === item.product
          })

          if (isActive) {
            s = 'pcOn'
            if (activeAgents[item.device_access_token].agent_connections?.length > 0) {
              for (let j = 0; j < activeAgents[item.device_access_token].agent_connections.length; j++) {
                if (isActive.handle === activeAgents[item.device_access_token].agent_connections[j].handle) {
                  s = 'live'
                  break
                }
              }
            }
          }
          agentInfo = activeAgents[item.device_access_token];
        }

        return {
          ...item,
          ...agentInfo,
          status: s,
        }
      }))
    }

  }, [items, activeAgents])


  const menuOptions = (
    <StyledMenuOptions
      options={[
        {
          icon: <Edit />,
          label: <IntlMessages id="home.pc.edit" />,
        },
        {
          icon: <Delete />,
          label: <IntlMessages id="home.pc.delete" />
        }
      ]}
      onClick={(option) => {
        console.log('option', option)
      }}
    />
  );



  return (
    <Card
      // hoverable
      bordered
      style={{
        borderRadius: 6,
        height: 136,
        backgroundColor: '#FFFFFF',
        padding: 10,
        paddingLeft: 14,
        ...style,
      }}
      styles={{ body: { padding: 0, height: "100%" } }}
    >

      <div style={{
        display: "flex",
        // flex: 1,
        flexDirection: "column",
        height: "100%",
      }}>
        <div style={{ display: "flex", height: 44, justifyContent: "space-between" }}>
          <Text
            style={{
              fontSize: 20,
              color: '#181818',
              paddingRight: 32,
            }}
          >
            {title}
          </Text>
          {props.extra}
        </div>
        <div style={{ display: "flex", flex: 1, flexDirection: "column", height: "calc(100% - 44px)", overflow: "auto" }}>
          {filteredListItems.map((item, idx) => {
            return <CardItem key={"cardItem"+idx} data={item} onClick={onClick}/>
          })}
        </div>
        {/*
          <ConnectButtonComponent agent={item}/> */}
      </div>
    </Card>
  );
};

export default SideCard;
